'use client';

import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';



interface NavItem {
  label: string;
  href: string;
  children?: {label: string;href: string;}[];
}

const navLinks: NavItem[] = [
{ label: 'Home', href: '/' },
{ label: 'Roetfilter Diagnose', href: '/roetfilter-diagnose' },
{
  label: 'Diensten',
  href: '/diensten',
  children: [
  { label: 'Roetfilter Reinigen', href: '/roetfilter-reinigen' },
  { label: 'Roetfilter Revisie', href: '/roetfilter-revisie' },
  { label: 'Roetfilter Vervangen', href: '/roetfilter-vervangen' },
  { label: 'Roetfilter Verwijderen', href: '/roetfilter-verwijderen' },
  { label: 'Katalysator Problemen', href: '/katalysator-problemen' },
  { label: 'EGR-klep Problemen', href: '/egr-klep-problemen' },
  { label: 'AdBlue Problemen', href: '/adblue-problemen' },
  { label: 'Bestelwagen Roetfilter', href: '/roetfilter-reinigen-bestelwagen' }]

},
{
  label: 'Per Merk',
  href: '/diensten',
  children: [
  { label: 'Audi Roetfilter', href: '/audi-roetfilter' },
  { label: 'BMW Roetfilter', href: '/bmw-roetfilter' },
  { label: 'Citroën Roetfilter', href: '/citroen-roetfilter' },
  { label: 'Honda Roetfilter', href: '/honda-roetfilter' },
  { label: 'Hyundai Roetfilter', href: '/hyundai-roetfilter' },
  { label: 'Jaguar Roetfilter', href: '/jaguar-roetfilter' },
  { label: 'Land Rover Roetfilter', href: '/land-rover-roetfilter' },
  { label: 'Mazda Roetfilter', href: '/mazda-roetfilter' },
  { label: 'Mercedes Roetfilter', href: '/mercedes-roetfilter' },
  { label: 'Peugeot Roetfilter', href: '/peugeot-roetfilter' },
  { label: 'Renault Roetfilter', href: '/renault-roetfilter' },
  { label: 'Seat Roetfilter', href: '/seat-roetfilter' },
  { label: 'Skoda Roetfilter', href: '/skoda-roetfilter' },
  { label: 'Subaru Roetfilter', href: '/subaru-roetfilter' },
  { label: 'Volkswagen Roetfilter', href: '/volkswagen-roetfilter' },
  { label: 'Volvo Roetfilter', href: '/volvo-roetfilter' }]

},
{
  label: 'Locaties',
  href: '/locaties',
  children: [
  { label: 'Alle Locaties', href: '/locaties' },
  { label: 'Roetfilter Reinigen Gent', href: '/roetfilter-reinigen-gent' },
  { label: 'Roetfilter Reinigen Sint-Niklaas', href: '/roetfilter-reinigen-sint-niklaas' },
  { label: 'Roetfilter Reinigen Dendermonde', href: '/roetfilter-reinigen-dendermonde' },
  { label: 'Roetfilter Reinigen Lokeren', href: '/roetfilter-reinigen-lokeren' },
  { label: 'Roetfilter Reinigen Aalst', href: '/roetfilter-reinigen-aalst' },
  { label: 'Roetfilter Reinigen Temse', href: '/roetfilter-reinigen-temse' },
  { label: 'Roetfilter Reinigen Deinze', href: '/roetfilter-reinigen-deinze' },
  { label: 'Roetfilter Reinigen Evergem', href: '/roetfilter-reinigen-evergem' },
  { label: 'Antwerpen', href: '/locaties/antwerpen' },
  { label: 'Brussel', href: '/locaties/brussel' },
  { label: 'Mechelen', href: '/locaties/mechelen' }]
},
{ label: 'Over Ons', href: '/over-roetfilter-center' },
{ label: 'FAQ', href: '/veelgestelde-vragen' },
{ label: 'Contact', href: '/contact' }];


function DropdownMenu({ items, onClose }: {items: {label: string;href: string;}[];onClose: () => void;}) {
  return (
    <div className="absolute top-full left-0 mt-2 w-80 max-h-[70vh] overflow-y-auto bg-white rounded-2xl shadow-xl border border-border/60 py-2 z-[95]">
      {items.map((item) =>
      <Link
        key={item.href}
        href={item.href}
        onClick={onClose}
        className="block px-5 py-2.5 text-[13px] font-semibold text-foreground hover:bg-secondary hover:text-primary transition-colors rounded-lg mx-1">
          {item.label}
        </Link>
      )}
    </div>);
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [mobileExpanded, setMobileExpanded] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {document.body.style.overflow = '';};
  }, [menuOpen]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      {/* Fixed promo bar */}
      <div className="fixed top-0 left-0 z-[70] h-12 w-full bg-[#0a1628] font-extrabold">
        <div className="flex h-full w-full flex-col items-center justify-center px-3 text-center leading-tight md:flex-row md:gap-6">
          <span className="text-[13px] sm:text-base md:text-lg lg:text-xl leading-none tracking-wide uppercase font-extrabold text-[#00ff6a] drop-shadow-[0_0_8px_rgba(0,255,106,0.8)]">
            NU 2X GRATIS EMISSIETEST
          </span>

          <span className="mt-1 text-[13px] sm:mt-0 sm:text-base md:text-lg lg:text-xl leading-none tracking-wide uppercase font-extrabold text-[#00ff6a] drop-shadow-[0_0_8px_rgba(0,255,106,0.8)]">
            75€ DIAGNOSE TERUGBETAALD
          </span>
        </div>
      </div>

      <header
        className={`relative mt-12 w-full z-50 transition-all duration-300 ${
        scrolled ?
        'bg-white/98 backdrop-blur-md shadow-md border-b border-border' :
        'bg-white/95 backdrop-blur-sm border-b border-border'}`
        }>
        
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between" ref={dropdownRef}>
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2.5 shrink-0">
            <AppImage
              src="/assets/images/Untitled_design__7_-1782403998447.png"
              alt="Roetfilter Center logo — roetfilter specialist Vlaanderen"
              width={44}
              height={44}
              priority
              className="h-10 w-auto object-contain" />
            
            <span className="font-black text-foreground text-base leading-tight hidden sm:block">
              Roetfilter<span className="text-primary"> Center</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden xl:flex items-center gap-0.5 text-[13px] font-bold text-muted-foreground">
            {navLinks.map((link) =>
            link.children ?
            <div key={link.label} className="relative">
                  <button
                onClick={() => setOpenDropdown(openDropdown === link.label ? null : link.label)}
                className="flex items-center gap-1 px-3 py-2 rounded-lg hover:text-foreground hover:bg-muted/60 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                    <svg className={`w-3 h-3 transition-transform ${openDropdown === link.label ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openDropdown === link.label &&
              <DropdownMenu items={link.children} onClose={() => setOpenDropdown(null)} />
              }
                </div> :

            <Link
              key={link.label}
              href={link.href}
              className="px-3 py-2 rounded-lg hover:text-foreground hover:bg-muted/60 transition-colors duration-200 whitespace-nowrap">
                  {link.label}
                </Link>

            )}
          </div>

          {/* CTA */}
          <div className="hidden xl:flex items-center gap-2.5">
            <Link
              href="/offerte"
              className="rc-cta-secondary px-4 py-2 text-[13px] whitespace-nowrap">
              Gratis Offerte
            </Link>
            <a
              href="tel:0498545474"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion('tel:0498545474'); }}
              className="rc-cta-primary flex items-center gap-1.5 px-4 py-2 text-[13px] whitespace-nowrap">
              <Icon name="PhoneIcon" size={13} variant="solid" />
              0498 54 54 74
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="xl:hidden p-2 rounded-lg text-foreground hover:bg-muted transition-colors"
            aria-label={menuOpen ? 'Menu sluiten' : 'Menu openen'}>
            <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
          </button>
        </nav>
      </header>

      {/* Mobile Menu Overlay */}
      {menuOpen &&
      <div className="fixed inset-0 z-[90] xl:hidden">
          <div
          className="absolute inset-0 bg-foreground/30 backdrop-blur-sm"
          onClick={() => setMenuOpen(false)} />
        
          <div className="absolute top-0 right-0 w-[88vw] max-w-[380px] h-full bg-white shadow-2xl flex flex-col pt-4 pb-8 overflow-y-auto">
            <div className="flex items-center justify-between px-6 pb-4 border-b border-border">
              <Link href="/" onClick={() => setMenuOpen(false)} className="flex items-center gap-2">
                <AppImage
                src="/assets/images/Untitled_design__7_-1782403998447.png"
                alt="Roetfilter Center"
                width={36}
                height={36}
                className="h-8 w-auto" />
              
                <span className="font-black text-sm">Roetfilter<span className="text-primary"> Center</span></span>
              </Link>
              <button onClick={() => setMenuOpen(false)} className="p-1.5 rounded-lg hover:bg-muted">
                <Icon name="XMarkIcon" size={20} />
              </button>
            </div>

            <nav className="flex flex-col gap-0.5 flex-1 px-4 pt-4">
              {navLinks.map((link) =>
            link.children ?
            <div key={link.label}>
                    <button
                onClick={() => setMobileExpanded(mobileExpanded === link.label ? null : link.label)}
                className="w-full flex items-center justify-between py-3 px-4 rounded-xl text-base font-bold text-foreground hover:bg-secondary hover:text-primary transition-colors">
                      {link.label}
                      <svg className={`w-4 h-4 transition-transform ${mobileExpanded === link.label ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {mobileExpanded === link.label &&
              <div className="ml-4 flex flex-col gap-0.5 mb-2">
                        {link.children.map((child) =>
                <Link
                  key={child.href}
                  href={child.href}
                  onClick={() => setMenuOpen(false)}
                  className="py-2 px-4 rounded-lg text-sm font-semibold text-muted-foreground hover:text-primary hover:bg-secondary transition-colors">
                            {child.label}
                          </Link>
                )}
                      </div>
              }
                  </div> :

            <Link
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="py-3 px-4 rounded-xl text-base font-bold text-foreground hover:bg-secondary hover:text-primary transition-colors">
                    {link.label}
                  </Link>

            )}
            </nav>

            <div className="flex flex-col gap-3 px-4 pt-6 border-t border-border mx-4">
              <Link
              href="/offerte"
              onClick={() => setMenuOpen(false)}
              className="rc-cta-secondary w-full text-center text-sm px-4 py-3">
                Gratis Offerte Aanvragen
              </Link>
              <a
              href="tel:0498545474"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion('tel:0498545474'); }}
              className="rc-cta-primary w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-bold">
                <Icon name="PhoneIcon" size={16} variant="solid" />
                BEL NU: 0498 54 54 74
              </a>
            </div>
          </div>
        </div>
      }

    </>);


}